import { addModelContext } from '@rails/document/React';
import { useResult } from '@rails/document/hooks';
import Show from '../Show';

const [Item, useItem] = addModelContext(
  ({
    me,
    // TODO jsonapiType,
    // id,
    useFetch,
    rotatable,
    deletable,
    isSelected,
    onClick,
    onLongPress,
  }) => {
    const fetcher = useFetch(); // on utiliser useFetch pourquoi ?
    const upload = useResult(fetcher);
    return (
      <div
        style={{ width: 200, height: 200 }}
        className='flex items-center justify-center'
      >
        <Show
          upload={upload}
          limit={200}
          rotatable={rotatable}
          deletable={deletable}
          onClick={onClick}
          onLongPress={onLongPress}
          selected={isSelected(upload?.id)}
        />
      </div>
    );
  },
);

Item.useResource = useItem;
export default Item;
